import { RestAPI } from './proxies';

export const getAdminSchedule = async (tournament) => {
    const response = await RestAPI.get(`/api/admin/schedule/${tournament}`);
    if (response.success) {
        return response.data;
    }
    throw new Error(response.error || 'Failed to fetch schedule');
};

export const scrapeAdminSchedule = async (tournament, seriesId) => {
    const response = await RestAPI.post('/api/admin/schedule/scrape', { tournament, seriesId });
    return response;
};

export const updateAdminSchedule = async (tournament, schedule, gameweeks) => {
    const response = await RestAPI.post('/api/admin/schedule', { tournament, schedule, gameweeks });
    return response;
};

export const getAdminPlayers = async (tournament) => {
    const response = await RestAPI.get(`/api/admin/players/${tournament}`);
    if (response.success) {
        return response.data;
    }
    throw new Error(response.error || 'Failed to fetch players');
};

export const scrapeAdminPlayers = async (tournament, teamUrls) => {
    const response = await RestAPI.post('/api/admin/players/scrape', { tournament, teamUrls });
    return response;
};

export const updateAdminPlayers = async (tournament, players) => {
    const response = await RestAPI.post('/api/admin/players', { tournament, players });
    return response;
};
